import React from 'react';
import { Field } from 'formik';
import { CustomSelectComponent, FsProps } from 'motion-components';
import { useTranslation } from 'react-i18next';

/** Κοινές τιμές grouping στο applog — για γρήγορο φιλτράρισμα (π.χ. logins) */
export const FieldSelectApplogGrouping = ({
  label,
  name = 'grouping',
  ...rest
}: FsProps) => {
  const { t } = useTranslation();
  label = label ? label : t('Grouping');

  const options = [
    { value: 'user-login', label: t('Είσοδος χρηστών (user-login)') },
    { value: 'LoginPage.AppVersion', label: 'LoginPage.AppVersion' },
  ];

  return (
    <Field
      {...rest}
      name={name}
      title={label}
      component={CustomSelectComponent}
      options={options}
      useCreatableSelect={true}
    />
  );
};
